// UNDERDAY dedicated PDP section behavior.
// Handles: option button selection (Pack / Color / Size), matching the
// selection to a real product variant, updating the hidden variant id
// input + displayed price, and gallery thumbnail/arrow navigation.
// No inline event handlers are used anywhere; everything is wired here.

function initUnderdayPdp(root) {
  if (root.dataset.underdayPdpInit === 'true') return;
  root.dataset.underdayPdpInit = 'true';

  const sectionId = root.dataset.sectionId;
  const dataScript = document.getElementById('underday-pdp-data-' + sectionId);
  if (!dataScript) return;

  let payload;
  try {
    payload = JSON.parse(dataScript.textContent);
  } catch (e) {
    return;
  }

  const variants = payload.variants || [];
  const selected = {};

  // Seed `selected` from whichever option buttons are already marked selected.
  root.querySelectorAll('[data-option-name].is-selected').forEach(function (btn) {
    selected[btn.getAttribute('data-option-name')] = btn.getAttribute('data-option-value');
  });

  const hiddenInput = document.getElementById('underday-variant-id-' + sectionId);
  const ctaButton = document.getElementById('underday-cta-' + sectionId);
  const priceWrap = document.getElementById('underday-price-' + sectionId);

  function findMatchingVariant() {
    return variants.find(function (v) {
      return Object.keys(selected).every(function (optionName) {
        return v.options[optionName] === selected[optionName];
      });
    });
  }

  function updatePriceDisplay(variant) {
    if (!priceWrap || !variant) return;
    let html = '<span class="underday-pdp__selected-price-current">' + variant.priceFormatted + '</span>';
    if (variant.compareAtPrice && variant.compareAtPrice > variant.price) {
      html += '<s class="underday-pdp__selected-price-compare">' + variant.compareAtPriceFormatted + '</s>';
    }
    priceWrap.innerHTML = html;
  }

  function updateCta(variant) {
    if (!ctaButton) return;
    const labelEl = ctaButton.querySelector('.underday-pdp__cta-label');
    if (!variant || !variant.available) {
      ctaButton.setAttribute('disabled', 'disabled');
      if (labelEl && ctaButton.dataset.soldOutLabel) {
        labelEl.textContent = ctaButton.dataset.soldOutLabel;
      }
    } else {
      ctaButton.removeAttribute('disabled');
      if (labelEl && ctaButton.dataset.buttonLabel) {
        labelEl.textContent = ctaButton.dataset.buttonLabel;
      }
    }
  }

  function selectOption(optionName, value, button) {
    selected[optionName] = value;

    root.querySelectorAll('[data-option-name="' + optionName + '"]').forEach(function (btn) {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-pressed', 'false');
    });
    button.classList.add('is-selected');
    button.setAttribute('aria-pressed', 'true');

    const variant = findMatchingVariant();
    if (variant) {
      if (hiddenInput) hiddenInput.value = variant.id;
      updatePriceDisplay(variant);
      updateCta(variant);
    }
  }

  root.querySelectorAll('[data-option-name]').forEach(function (button) {
    button.addEventListener('click', function () {
      selectOption(
        button.getAttribute('data-option-name'),
        button.getAttribute('data-option-value'),
        button
      );
    });
  });

  // Gallery: thumbnail + arrow navigation.
  const gallery = root.querySelector('[data-underday-gallery]');
  if (gallery) {
    const mainItems = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-main-item]'));
    const thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-gallery-thumb]'));

    function showIndex(index) {
      if (mainItems.length === 0) return;
      const nextIndex = (index + mainItems.length) % mainItems.length;
      mainItems.forEach(function (item, i) {
        const isActive = i === nextIndex;
        item.classList.toggle('is-active', isActive);
        if (isActive) {
          item.removeAttribute('hidden');
        } else {
          item.setAttribute('hidden', 'hidden');
        }
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === nextIndex);
      });
    }

    function currentIndex() {
      const active = mainItems.findIndex(function (item) {
        return item.classList.contains('is-active');
      });
      return active === -1 ? 0 : active;
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        showIndex(i);
      });
    });

    const prevBtn = gallery.querySelector('[data-gallery-prev]');
    const nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showIndex(currentIndex() - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showIndex(currentIndex() + 1); });
  }
}

function initAllUnderdayPdps() {
  document.querySelectorAll('.underday-pdp').forEach(initUnderdayPdp);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllUnderdayPdps);
} else {
  initAllUnderdayPdps();
}

document.addEventListener('shopify:section:load', initAllUnderdayPdps);
